<div class="table-responsive" id="metadataTableContainer">
  <div role="table" class="table-view border border-top-0" [style.width]="tabelWidth+'px'" [style.min-width]="'100%'"
    *ngIf="showView">
    <ng-container>
      <!-- outer node -->
      <div class="table-view-header" *ngIf="dataReceived" role="rowgroup">
        <div id="tablePanel" class="thead d-flex justify-content-between flex-nowrap border-bottom" role="row">
          <div class="th d-flex px-1" role="columnheader" *ngFor="let column of listOfColumn" [ngClass]="column.class"
            [style.min-width]="column.width+'px'" [style.width]="column.width+'px'"
            [style.max-width]="column.width+'px'">
            <p class="font-bold h-text mb-1 pt-1">{{column.name ? column.name : column.display_name}}</p>
          </div>
        </div>
      </div>

      <ng-template #branch let-items>

        <div *ngFor="let item of items">
          <ng-container *ngTemplateOutlet="leaf; context: {item: item}"></ng-container>
        </div>

      </ng-template>

      <!-- leaf node -->


      <ng-template let-item="item" #leaf>

        <div class="card tabular-tree-view">
          <div class="card-header p-0 border-0" *ngIf="isFilterApplied ? item.isSearchResult : (isConfigured ? (item['level'] >= firstNodeLevel) : true)">
            <div class="tbody">
              <div class="row mx-0 tr justify-content-between flex-nowrap border-bottom" role="row" *ngIf="item"
                [class.active]="clicked === item.id" [ngClass]="{'mark':item.isHighlighted, 'dim':isConfigured && checkLevelConfig(item.level)}">
                <div role="rowheader" class="d-flex align-items-start td px-1" id="{{column.internal_name}}"
                  *ngFor="let column of listOfColumn; let columnIndex = index" [ngClass]="column.class"
                  [style.min-width]="column.width+'px'" [style.width]="column.width+'px'"
                  [style.max-width]="column.width+'px'">
                  <ng-container *ngIf="columnIndex === 0">
                    <div [style.padding-left]="calculatePadding(item.level)">
                      <ng-container *ngIf="item.children?.length!==0">
                        <button class="btn btn-toggle"
                          *ngIf="isFilterApplied ? (item.children?.length && checkVisibility(item.children)) : true"
                          [ngClass]="[item.expand?'':'collapsed']" (click)="item.expand = !item.expand"
                          [attr.aria-label]="('click to ' + (item.expand ? 'collapse ' : 'expand ') + 'node ' + item[column.propName])">
                        </button>
                      </ng-container>

                      <span *ngIf="item.children?.length===0" class="last-node float-left pl-0" id="{{ item.id }}-atag">
                      </span>
                    </div>
                  </ng-container>
                  <div *ngIf="column.propName==='full_statement'"
                    class="w-100 d-flex justify-content-start align-items-start overflow-x">

                    <button
                        id="{{item.id}}-{{'node'}}"
                        *ngIf="!item.isOrphanLabel"
                        class="btn btn-node w-95 pl-0"
                        (click)="openDetails(item,false);"
                        [attr.aria-label]=
                            "'node- '
                            + item[column.propName]
                            + ((clicked === item.id) ? '': ', 
                            click to get node details')">
                      <div [mathJax]="item.is_document === 1 ? (item['title']) :
                        (item[column.propName+'_html'] ? item[column.propName+'_html'] : item[column.propName])"
                        class="tree-long-field w-100"></div>
                    </button>
                    <p class="font-3x mb-0" id="{{item.id}}-{{'node'}}" *ngIf="item.isOrphanLabel">
                      {{item[column.propName+'_html'] ? item[column.propName+'_html'] : item[column.propName]}}
                    </p>

                    <ng-container *ngIf="column.propName==='compStatus'">
                      <ul class="list-inline mb-0 text-right mr-2">
                        <li class="list-inline-item" aria-label="Node has comment"
                          *ngIf="assignedToMe === 'all' &&  item.open_comment_count > 0 && showComments">
                          <em class="material-icons-outlined font-4x" aria-hidden="true">chat_bubble_outline</em>
                        </li>

                        <li class="list-inline-item" aria-label="Node has comment"
                          *ngIf="assignedToMe === 'assignedToMe' && item.isCommented === true  && showComments">
                          <em class="material-icons-outlined font-4x" aria-hidden="true">chat_bubble_outline</em>
                        </li>
                      </ul>
                    </ng-container>

                    <ng-container *ngIf="column.propName==='edit' && !item.isOrphanLabel">
                      <button 
                          [disabled]="!isEditable || !item.is_editable"
                          class="btn btn-icon btn-edit tooltip left sm font-1x position-relative"
                          [attr.aria-label]="'Edit'"
                          data-tooltip="Edit"
                          id="{{item.id}}-{{'editnode'}}"
                          (click)="openDetails(item,true)">
                        <em class="material-icons-outlined font-4x" aria-hidden="true">edit</em>
                      </button>
                    </ng-container>

                  </div>



                  <p class="mb-0 text-wrapped-all"
                    [mathJax]="item[column.propName + '_html'] ? item[column.propName + '_html']: item[column.propName]"
                    *ngIf="column.propName!=='full_statement' && column.propName !=='compStatus' && column.propName !=='human_coding_scheme'">
                  </p>

                  <p class="mb-0" *ngIf="column.propName ==='human_coding_scheme'">
                    {{item[column.propName] | slice:0:charLimit}}
                    <span
                      *ngIf="item[column.propName] && item[column.propName].length>charLimit && column.propName ==='human_coding_scheme'">...</span>
                  </p>

                  <ng-container *ngIf="column.propName==='compStatus'">
                    <div>
                      <div class="tooltip top position-relative" [attr.aria-label]="'Node has comment'" data-tooltip="Node has comment"
                      *ngIf="assignedToMe === 'all' &&  item.open_comment_count > 0 && showComments">
                      <span class="material-icons-outlined font-4x" aria-hidden="true">chat_bubble_outline</span>
                    </div>
                      <div class="tooltip top position-relative"
                      [attr.aria-label]="'Node has comment'" data-tooltip="Node has comment"
                      *ngIf="assignedToMe === 'assignedToMe' && item.isCommented === true  && showComments">
                        <em class="material-icons-outlined font-4x" aria-hidden="true">chat_bubble_outline</em>
                      </div>

                      <!-- API has been commented off for the project tree image, future when it will be used needs to update the material icon -->
                      <div class="tooltip left position-relative" [attr.aria-label]="'Node compliant'"
                        data-tooltip="Node compliant"
                        *ngIf="column.propName==='compStatus' && item[column.propName] === 0">
                        <img alt="Node compliant" class="img-fluid" src="assets/images/ic_complete.png">
                      </div>
                      <div class="tooltip left position-relative"
                        [attr.aria-label]="'Node partially compliant'" data-tooltip="Node partially compliant"
                        *ngIf="column.propName==='compStatus' && item[column.propName] === 1">
                        <img alt="Node partially compliant" class="img-fluid" src="assets/images/ic_not_complete.png">
                      </div>
                      <div class="tooltip left position-relative"
                        [attr.aria-label]="'Node not compliant'" data-tooltip="Node not compliant"
                        *ngIf="column.propName==='compStatus' && item[column.propName] === 2">
                        <img alt="Node not compliant" class="img-fluid" src="assets/images/ic_not_started.png">
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="column.propName==='edit' && !item.isOrphanLabel">
                    <button
                        id="{{item.id}}-{{'editnode'}}"
                        [disabled]="!isEditable || !item.is_editable"
                        class="btn btn-icon btn-edit tooltip left sm font-1x position-relative"
                        [attr.aria-label]="'Edit'"
                        data-tooltip="Edit" 
                        (click)="openDetails(item,true)">
                      <em class="material-icons-outlined font-4x" aria-hidden="true">edit</em>
                    </button>
                  </ng-container>

                </div>
              </div>
            </div>
          </div>


          <div id="{{item.id}}" aria-labelledby="headingOne">
            <div class="card-body">
              <div class="tbody"
                *ngIf="(item['itemExemplars'] && item['itemExemplars'].length>0) || (item['itemAssets'] && item['itemAssets'].length>0)">
                <div class="row mx-0 tr justify-content-between">
                  <div class="{{dynamicClass}}" [style.padding-left]="calculatePadding(item.level)">

                    <div class="associated">

                      <ng-container *ngIf="item['itemAssociations'] && item['itemAssociations'].length > 1">

                        <ng-container *ngFor="let item of item['itemAssociations'];let $index = index">
                          <ng-container *ngIf="item.association_type.display_name !=='isChildOf'">

                            <p class="mb-1 associated-destination"
                              *ngIf="item && ((item.destination_node.human_coding_scheme && item.destination_node.human_coding_scheme.length >0) ||
                                (item.destination_node.full_statement && item.destination_node.full_statement.length >0))">                              
                                <span class="icon material-icons-outlined font-4x" aria-hidden="true">attachment</span>
                              <span class="human_coding font-bold"
                                *ngIf="item.destination_node.human_coding_scheme && item.destination_node.human_coding_scheme.length >0">
                                {{item.destination_node.human_coding_scheme | slice:0:charLimit}}:</span>
                              <span
                                *ngIf="item.destination_node.human_coding_scheme && item.destination_node.human_coding_scheme.length>charLimit">...</span>
                              <span class="full_statement"
                                *ngIf="item.destination_node.full_statement && item.destination_node.full_statement.length >0">
                                {{item.destination_node.full_statement | slice:0:charLimit}}</span>
                              <span
                                *ngIf="item.destination_node.full_statement && item.destination_node.full_statement.length>charLimit">...</span>
                            </p>

                          </ng-container>

                        </ng-container>
                      </ng-container>

                      <!-- Association end -->

                      <div>
                        <ng-container *ngIf="item['itemExemplars'] && item['itemExemplars'].length>0">

                          <div *ngFor="let exemplar of item['itemExemplars'];let $index=index">
                            <ng-container *ngIf="exemplar['has_asset'] === 1">
                              <span class="associated-file">
                                <span class="icon material-icons-outlined font-4x" aria-hidden="true">attachment</span>
                                <a href="{{exemplar.external_url}}" target="_blank" aria-label="Click to preview asset"
                                  class="text-link" rel="noopener">
                                  {{exemplar['asset_file_name'].substr(0,exemplar['asset_file_name'].lastIndexOf('.'))| slice:0:filenameCharlmt}}
                                  <span
                                    *ngIf="exemplar['asset_file_name'].substr(0,exemplar['asset_file_name'].lastIndexOf('.')).length>filenameCharlmt">...</span>.{{exemplar['asset_file_name'].substr(exemplar['asset_file_name'].lastIndexOf('.')
                                  + 1)}}</a></span>

                            </ng-container>
                            <ng-container *ngIf="exemplar['has_asset'] === 0">
                              <span class="associated-file text-truncate">
                                <span class="icon material-icons-outlined font-4x" aria-hidden="true">attachment</span>
                                <a href="{{exemplar.external_url}}" class="text-link" target="_blank" rel="noopener"
                                  aria-label="Click to preview the URL">{{exemplar['external_download_url']}}</a></span>
                            </ng-container>

                          </div>

                        </ng-container>
                      </div>
                      <!-- Exemplar end -->
                      <div>
                        <ng-container *ngFor="let asset of item['itemAssets'];let $index=index">
                          <span class="associated-file">
                            <span class="icon material-icons-outlined font-4x" aria-hidden="true">attachment</span>
                            <a href="{{asset.preview_url}}" target="_blank" aria-label="Click to preview asset"
                              class="text-link" rel="noopener">
                              {{asset['asset_file_name'].substr(0,asset['asset_file_name'].lastIndexOf('.'))| slice:0:filenameCharlmt}}<span
                                *ngIf="asset['asset_file_name'].substr(0,asset['asset_file_name'].lastIndexOf('.')).length>filenameCharlmt">...</span>.{{asset['asset_file_name'].substr(asset['asset_file_name'].lastIndexOf('.')
                              + 1)}}</a></span>

                        </ng-container>
                      </div>
                      <!-- Document End-->
                    </div>
                  </div>
                  <div *ngFor="let class of listOfClass" [ngClass]="class.class"></div>

                </div>
              </div>

              <ng-container *ngIf="showChildrenContainer(item)">

                <ng-container *ngTemplateOutlet="branch; context: { $implicit : item.children}"></ng-container>

              </ng-container>

            </div>
          </div>
        </div>

      </ng-template>
      <ng-container *ngTemplateOutlet="branch; context:{ $implicit: items}">
      </ng-container>

      <app-tabular-tree-side-pane #tabularTreeSidePaneComponent [showUserFriendlyPage]="showUserFriendlyPage"
        [isAllNode]="isAllNode" [taxonomyData]="rawTreeData"
        (nextClickEvent)="onNextNavigationClick($event);" [showNavigation]="showNavigation"
        [selectedNode]="selectedNode" (previousClickEvent)="onPreviousNavigationClick($event);"
        [templateSelected] = "templateSelected"
        (sidePanelClosed)="updateFocus($event);">

      </app-tabular-tree-side-pane>

      <app-preloader *ngIf="!dataReceived" [loaderText]="'Loading Table..'"
        class="w-100 position-fixed preloader-backdrop"></app-preloader>
    </ng-container>
  </div>
</div>
